import React from "react";
import styled from "@emotion/styled";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const FieldsetWrapper = styled.div(({ fullWidth, error }) => ({
  width: fullWidth ? "100%" : "auto",
  position: "relative",
  display: "flex",
  flexDirection: "column",

  "& .react-datepicker-wrapper": {
    width: "100%",
  },

  "& input": {
    width: "100%",
    height: "45px",
    padding: "12px 16px",
    fontSize: ".9rem",
    borderRadius: "8px", 
    border: `1px solid ${error ? "#d32f2f" : "#c4c4c4"}`,
    backgroundColor: "transparent",
    color: "#333",
    outline: "none",
    cursor: "pointer !important",
    transition: "border-color 0.2s",
    boxSizing: "border-box",
  },

  "& input:focus": {
    borderColor: "#3f51b5", 
    borderWidth: "2px",
    padding: "11px 15px", 
  },

  "& input:hover": {
    borderColor: "#000",
  },
}));

const FloatingLabel = styled.label({
  position: "absolute",
  left: "12px",
  top: "-10px", 
  backgroundColor: "#fff", 
  padding: "0 5px",
  fontSize: "0.75rem",
  color: "#757575",
  zIndex: 1,
  pointerEvents: "none",
});

const CalendarIcon = styled.div({
  position: "absolute",
  right: "15px",
  top: "50%",
  transform: "translateY(-50%)",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  color: "#000",
  "& svg": {
    width: "20px",
    height: "20px",
  },
});

const DatePicker = ({
  label = "From Date",
  onChange,
  selected,
  dateFormat = "dd/MM/yy",
  placeholder = "dd/mm/yyyy",
  fullWidth = true,
  error = false,
  helperText,
  ...props
}) => (
  <FieldsetWrapper fullWidth={fullWidth} error={error}>
    {label && <FloatingLabel>{label}</FloatingLabel>}

    <CustomCalendarIcon />

    <CustomDatePicker
      selected={selected}
      onChange={(date) => onChange(date)}
      dateFormat={dateFormat}
      placeholderText={placeholder}
      showPopperArrow={false}
      autoComplete="off"
      popperPlacement="bottom-start"
      {...props}
    />

    {error && helperText && (
      <span
        style={{
          color: "#d32f2f",
          fontSize: "0.75rem",
          marginTop: "4px",
          marginLeft: "14px",
        }}
      >
        {helperText}
      </span>
    )}
  </FieldsetWrapper>
);

const CustomCalendarIcon = () => (
  <CalendarIcon>
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
      <line x1="16" y1="2" x2="16" y2="6"></line>
      <line x1="8" y1="2" x2="8" y2="6"></line>
      <line x1="3" y1="10" x2="21" y2="10"></line>
    </svg>
  </CalendarIcon>
);

// تمرير الستايل للـ DatePicker
const CustomDatePicker = styled(ReactDatePicker)({});

export default DatePicker;
